import { DetectorGroupOption } from "./types";

export const DETECTOR_GROUP_ALL_OPTION: DetectorGroupOption = {
  label: "All",
  value: "DETECTOR_GROUP_ALL_OPTION",
};

export const DETECTOR_GROUP_CREATE_NEW_OPTION: DetectorGroupOption = {
  label: "Create New Group",
  value: "DETECTOR_GROUP_CREATE_NEW_OPTION",
  bold: true,
};

export const DETECTOR_GROUP_DEFAULT_OPTION: DetectorGroupOption = {
  label: "Default",
  value: "DETECTOR_GROUP_DEFAULT_OPTION",
};
